<template>
	<div class="gb-photoalbum-content-item-album ma-2">
		<GBPhotoAlbumItemNotReference v-if="!album.reference" class="album-mark" />
		<v-card  class="item-album" raised hover @click="onClickAlbum()">
			<div class="header">
				<v-layout align-center fill-height row>
					<div class="title-text">{{album.title}}</div>
					<v-btn class="ma-0" small @click.stop="onClickMenu" icon><v-icon small>menu</v-icon></v-btn>
					<transition>
						<div class="menu" @click.stop>
							<div class="menu-list-group" v-if="is_menu_opened">
								<v-btn flat block large class="menu-list-item caption ma-0"
									color="#1976d2"
									:disabled="download_album"
									@click="onClickDownloadAlbum"
								>ダウンロード</v-btn>
								<v-btn flat block large class="menu-list-item caption ma-0"
									color="#ff5252"
									@click="onClickDeleteAlbum"
								>削除</v-btn>
							</div>
						</div>
					</transition>
				</v-layout>
			</div>
			<v-layout align-center fill-height row class="sub-header">
				<div class="sub-text" style="width: 100%">{{subTitle}}</div>
				<div class="sub-text" style="width: 50px; text-align: right;" v-if="album.items.length > 0">{{album.items.length}}枚</div>
			</v-layout>
				<div class="photo-content">
						<div v-for="(item, index) in album.items"
							:key="index"
							v-bind:style="styleThumbnail(index)"
							v-bind:class="classthumbnailSize(index)">
								<v-lazy-image :src="item.thumbnail_uri" class="photo" />
						</div>
				</div>
		</v-card>
	</div>
</template>
<script>
import VLazyImage from 'v-lazy-image';
import GBPhotoAlbumItemNotReference from './GBPhotoAlbumItemNotReference';
import MouseState from '../../classes/MouseState';
import MouseStateMachine from '../../classes/MouseStateMachine';
import Util from '../../classes/Util';
import { DATETIME_FORMAT } from '../../data/Const';

const strftime = require('strftime');
const THUMBNAILS_DISPLAY_LIMIT = 4;

export default {
	name: 'GBPhotoAlbumContentItemAlbum',
	props: [
		"album", "download_album"
	],
	data (){
		const state_default = new MouseState({
			down: (e) => {
				let obj = e.targetTouches ? e.targetTouches[0] : e;
				if(!obj.target.closest('.menu')){
					this.is_menu_opened = false;
				}
			},
		});
		return{
			is_menu_opened: false,
			msm: new MouseStateMachine(state_default),
		}
	},
	components: {
		VLazyImage,
		GBPhotoAlbumItemNotReference,
	},
	methods: {
		onClickMenu: function() {
			this.is_menu_opened = !this.is_menu_opened;
		},
		onClickAlbum: function() {
			let uri = '/' + [this.$route.params.contractor_id, 'photoalbum', 'project', this.album.project_id, 'album'].join('/') + '/#' + this.album.id;
			this.$router.push(uri);
		},
		onClickDownloadAlbum: function() {
			this.is_menu_opened = !this.is_menu_opened;
			this.$emit('download-album', this.album);
		},
		onClickDeleteAlbum: function() {
			this.is_menu_opened = !this.is_menu_opened;
			this.$emit('delete-album', this.album);
		},
	},
	computed: {
		subTitle: function() {
			let utc = Util.getUTCFromYMDHMS(this.album.last_modified_at);
			return strftime(DATETIME_FORMAT, new Date(utc))
		},
		classthumbnailSize: function() {
			return function() {
				if (this.album.items.length === 1)
					return 'one-all';
				else if (this.album.items.length === 2)
					return 'half';
				else if (this.album.items.length === 3)
					return 'third';
				else
					return 'quarter';
			};
		},
		styleThumbnail: function() {
			return function(index) {
				if (index > THUMBNAILS_DISPLAY_LIMIT - 1)
					return {"display": 'none'};
				return '';
			};
		},
	},
	mounted() {
		this.msm.bind(window);
	},
	beforeDestroy() {
		this.msm.unbind();
	},
};

</script>
<style>
	.gb-photoalbum-content-item-album .item-album {
		position: relative;
		width: 202px;
		height: 247px;
		max-width: 202px;
		min-width: 202px;
	}
	.gb-photoalbum-content-item-album .item-album .header {
		width: 100%;
		height: 30px;
		padding-left: 4px;
		padding-right: 0px;
		background-color: #f5f5f5;
	}
	.gb-photoalbum-content-item-album .item-album .title-text {
		font-size: 14px;
		width: 100%;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	.gb-photoalbum-content-item-album .item-album .sub-header {
		height: 15px;
		padding-left: 4px;
		padding-right: 4px;
	}
	.gb-photoalbum-content-item-album .item-album .sub-text {
		font-size: 12px;
	}
	.gb-photoalbum-content-item-album .item-album .photo-content {
		position: relative;
		width: 202px;
		height: 202px;
		margin: 0px;
		padding: 0px;
	}
	.gb-photoalbum-content-item-album .item-album .photo {
		border: solid 1px #ffffff;
		vertical-align: middle;
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
	.gb-photoalbum-content-item-album .item-album .one-all {
		position: relative;
		display: inline-block;
		width: 100%;
		height: 100%;
	}
	.gb-photoalbum-content-item-album .item-album .half {
		position: relative;
		display: inline-block;
		width: 50%;
		height: 100%;
	}
	.gb-photoalbum-content-item-album .item-album .third {
		position: absolute;
		width: 50%;
		height: 50%;
	}
	.gb-photoalbum-content-item-album .item-album .third:first-child {
		top: 0;
		left: 0;
		height: 100% !important;
	}
	.gb-photoalbum-content-item-album .item-album .third:nth-of-type(2) {
		top: 0;
		left: 50%;
	}
	.gb-photoalbum-content-item-album .item-album .third:last-child {
		top: 50%;
		left: 50%;
	}
	.gb-photoalbum-content-item-album .item-album .quarter {
		position: relative;
		display: inline-block;
		width: 50%;
		height: 50%;
	}
	.gb-photoalbum-content-item-album .item-album .menu-list-group {
		position: absolute;
		top: -30px;
		right: 40px;
		width: 100px;
		background-color: white;
		border:solid 1px #DFDFDF;
		border-bottom: none;
	}
	.gb-photoalbum-content-item-album .item-album .menu-list-item {
		display: flex;
		justify-content: center;
		height: 30px !important;
		border-bottom:solid 1px #DFDFDF;
	}
</style>
<style scoped>
	.v-enter-active, .v-leave-active {
		transition: all 0.3s;
	}
	.v-enter {
		transform: translateY(-10px);
	}
	.v-enter, .v-leave-to {
		opacity: 0;
	}
</style>
